module.exports = __webpack_public_path__ + "static/media/main idea.4ab7f3d5.mp3";